import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLSelect, DLTextField } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllAdvertisersTable from './Table';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllAffiliatesView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            affiliates: [],
            searchValue: '',
            affiliateQueryObject: {
                sort: 'affiliateType,advertisers.advertiser_name',
                search: undefined,
                affiliate: undefined,
            },
        };
    }
    componentDidMount() {
        this.loadAffiliates();
    }
    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.affiliates = [];
                prevState.affiliateQueryObject.search = this.state.searchValue || undefined;
                return prevState;
            } );
            this.loadAffiliates();
        }
    }
    onFilter = ( key, value ) => {
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.affiliates = [];
            prevState.affiliateQueryObject[ key ] = value;
            return prevState;
        } );
        this.loadAffiliates();
    }
    loadAffiliates = () => {
        return this.props.getAffiliateAdvertisers( this.state.affiliateQueryObject )
        .then( ( affiliates ) => {
            this.setState( {
                fetching: false,
                affiliates: affiliates,
            } );
            return affiliates;
        } );
    }
    advertiserUpdated = () => {
        this.setState( {
            fetching: true,
            affiliates: [],
        }, () => {
            this.loadAffiliates();
        } );
    }
    onColumnSort = ( value ) => {
        if( this.state.affiliateQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.affiliates = [];
            prevState.affiliateQueryObject.sort = value;
            return prevState;
        } );
        this.loadAffiliates();
    }

    render() {
        const { fetching, affiliates, searchValue } = this.state;
        const affiliateTypeOptions = [
            { text: '', value: null },
            { text: 'Amazon', value: 'Amazon' },
            { text: 'CJ', value: 'CJ' },
            { text: 'Rakuten', value: 'Rakuten' },
            { text: 'Target', value: 'Target' },
        ];

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Affiliates and Advertisers</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/affiliates' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                        <Link to='/admin/affiliates/manage' className={ style.tabOption }
                        data-active={ false }>Manage</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allAffiliate }>
                        <div className={ style.filters }>
                            <span style={ { marginRight: '20px' } }>Filter By</span>
                            <DLSelect placeholder='Affiliate Type' options={ affiliateTypeOptions }
                            value={ this.state.affiliateQueryObject.affiliate }
                            onChange={ ( e, { value } ) => { this.onFilter( 'affiliate', value ); } }
                            style={ { width: '170px' } }
                            noError />
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllAdvertisersTable
                            affiliates={ affiliates }
                            onColumnSort={ this.onColumnSort }
                            currentSort={ this.state.affiliateQueryObject.sort }
                            onAdvertiserUpdated={ this.advertiserUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getAffiliateAdvertisers: ( queryObject ) => {
            return dAPI.get( '/affiliates/dbadvertisers', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllAffiliatesView );
